import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Modal from 'react-bootstrap-modal'

import EventForm from './../Event'

export default class EditEventModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object,
    dates: PropTypes.array,
    currentDay: PropTypes.number
  }

  static defaultProps = {
    isOpen: false
  }

  render() {
    const { isOpen, onClose, dates, event, currentDay, user } = this.props

    return !!event ? (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="event-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <EventForm user={user} isFluid={true} dates={dates} event={event} initialDay={currentDay} onSave={() => onClose()} />
          <i className="event-modal__close icon-close" onClick={() => onClose()} />
        </Modal.Body>
      </Modal>
    ) : null
  }
}



// WEBPACK FOOTER //
// src/components/TripPlanner/EditEventModal.js